/**
 * jobBriefFeatureFlag.js — Resolves which Job Brief version to render.
 *
 * Precedence (highest → lowest):
 *   1. Explicit URL query ?jb=v1 or ?jb=v2      → session-scoped opt-in
 *   2. localStorage['jobBriefVersion']          → per-user opt-in
 *   3. process.env.REACT_APP_JOB_BRIEF_V2       → deployment default
 *   4. 'v1'                                     → safe fallback
 *
 * This is a pure function — no side effects except when the URL param
 * asks us to persist the choice.
 */
export function resolveJobBriefVersion(search = typeof window !== 'undefined' ? window.location.search : '') {
  const params = new URLSearchParams(search);
  const q = params.get('jb');
  if (q === 'v1' || q === 'v2') {
    try { localStorage.setItem('jobBriefVersion', q); } catch { /* quota */ }
    return q;
  }
  try {
    const stored = localStorage.getItem('jobBriefVersion');
    if (stored === 'v1' || stored === 'v2') return stored;
  } catch { /* private mode */ }
  return process.env.REACT_APP_JOB_BRIEF_V2 === 'true' ? 'v2' : 'v1';
}

export function isJobBriefV2Enabled() {
  return resolveJobBriefVersion() === 'v2';
}
